/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOwnerAccountIFSCDetails } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  beneLookUp,
  resetBeneData,
  resetPANVerification,
  verifyThisPAN,
} from "../../../redux/features/verifyPAN/verifyPAN";

import { useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";

import {
  beneBankLookUp,
  beneCategories,
  beneVerifyThisBank,
  resetBankError,
  resetBeneVerifyThisGst,
} from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";

import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";

import CreateFieldForcePanDetails from "../../../components/FieldForceAccount/FieldForceAccountCreate/CreateFieldForcePanDetails";
import FieldFieldBankDetails from "../../../components/FieldForceAccount/FieldForceAccountCreate/FieldFieldBankDetails";
import FieldForceContactDetails from "../../../components/FieldForceAccount/FieldForceAccountCreate/FieldForceContactDetails";
import FieldForceCategoryAndLabels from "../../../components/FieldForceAccount/FieldForceCategoryAndLabels";
import FieldForceConfirmAccount from "../../../components/FieldForceAccount/FieldForceConfirmAccount";
import SmallPopup from "../../../components/_utils/CommonSmallPopup";
import SVGComponent from "../../../components/_utils/SVGComponent";
import { createFieldForceAccount } from "../../../redux/features/accounts/fieldForceAccount";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const FieldForceAccountCreate = ({ flow }) => {
  const scrollIt = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);

  const [newMessage, setNewMessage] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [isLinkedAccount, setIsLinkedAccount] = useState(false);
  const [accountType, setAccountType] = useState({
    type: "",
    id: "",
    name: "",
  });
  const [lookupNext, setLookupNext] = useState(false);
  const [bankAccountType, setBankAccountType] = useState({ type: "", id: "" });
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [shutViewAll, setShutViewAll] = useState(false);
  const [isAchived, setIsArchived] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [isDennied, setIsDennied] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [bankAccountName, setBankAccountName] = useState("");
  const [activeStep, setActiveStep] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [bankIsDennied, setBankIsDennied] = useState(false);
  const [bankIsPending, setBankIsPending] = useState(false);
  const [bankLookupNext, setBankLookupNext] = useState(false);
  const [bankIsAchived, setBankIsArchived] = useState(false);
  const [bankIsApproved, setBankIsApproved] = useState(false);
  const [bankSelectedItem, setBankSelectedItem] = useState(null);
  const [bankDisableCreateNext, setBankDisableCreateNext] = useState(false);
  const [nonArchive, setNonArchive] = useState(false);

  const [hideBankBlock, setBankHideBlock] = useState(false);
  const [bankShutViewAll, setBankShutViewAll] = useState(false);
  const [isButtonDisabled] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [showAction, setShowAction] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const [hideCreate, setHideCreate] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [hideBlock, setHideBlock] = useState(false);
  const [bankUnachivedOpenPop, setBankUnachivedOpenPop] = useState(false);
  const [bankAchivedOpenPop, setBankAchivedOpenPop] = useState(false);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState([]);
  const [contactBol, setContactBol] = useState({
    email: "",
    contact: "",
    accountname: "",
  });
  const [active, setActive] = useState(false);
  const [bankUserInfo, setBankUserInfo] = useState([]);
  const [showAccInfo, setShowAccInfo] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [showRejectAllTxnReson, setShowRejectAllTxnReson] = useState(false);
  const [GSTStatus, setGSTStatus] = useState(null);
  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);

  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    gstin: "",
    name: "",
    categories: "",
    panNumber: "",
    gst_org_name: "",
    account_name: "",
    labels: [],
    recipient_email: "",
    reimbursement_account: flow === "reimbursement" ? true : false,
    reimbursement_user_id: "",
    userName: "",
    userId: "",
    amount: GlobalConfiguration.defaultAmount,
    virtual: "",
  });
  const [manualVirtualAccount, setManualVirtualAccount] = useState(false);
  const bankStatus = useSelector(
    (state) => state.beneAllVerification.verifyBank,
  );

  const isBankError = useSelector(
    (state) => state.beneAllVerification.isBankError,
  );
  const { ownerAccIfscData, ownerAccIfscError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const { verifyBank, verifyBankisLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  const categories = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  ).filter((cat) => cat?.active === "Y");

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const { createFieldForceAccountLoading } = useSelector(
    (state) => state.fieldForceAccount,
  );

  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const {
    verifyPAN,
    beneLookData,
    beneLookLoading,
    verifyPANisLoading,
    beneLookError,
  } = useSelector((state) => state.verify);

  const { beneLookLoading: beneBankLookLoading } = useSelector(
    (state) => state.beneAllVerification,
  );
  const [showModalPopup, setShowModalPopup] = useState(false);
  const [showAlertCategories, setShowAlertCategories] = useState(false);
  const [selectedValue, setSelectedValue] = useState("legalname");
  const [createDisabled, setCreateDisabled] = useState(false);
  const [selectedValueAmount, setSelectedValueAmount] =
    useState("defaultAmount");
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedCatFields, setSelectedCatFields] = useState([]);
  const [direction, setDirection] = useState(null);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [recipients, setRecipients] = useState([]);
  const [createRecipient, setCreateRecipient] = useState([]);
  const [showRupeeSymbol, setShowRupeeSymbol] = useState(false);
  const isVerifiedPan = verifiedPan === true;
  const shouldLookupNext = lookupNext === true;
  const isBeneLookDataNull = beneLookData === null;
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const isIFSCValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
    ifscRegex.test(payload?.ifsc_code);

  const [virtualAccount, setVirtualAccount] = useState(false);
  const [freshAccount, setFreshAccount] = useState(true);
  const steps = [
    "PAN details",
    "Bank details",
    "User, transaction limit and contact details",
    "Category, labels and recipients",
    "Confirm and create",
  ];
  const bankStatusLoading = useSelector(
    (state) => state.beneAllVerification.verifyBankisLoading,
  );

  const shouldEnableNextButtonFirstStepper =
    isBeneLookDataNull &&
    isVerifiedPan &&
    payload?.gstin?.length === GlobalConfiguration.gstLength &&
    GSTStatus
      ? true
      : isBeneLookDataNull &&
          isVerifiedPan &&
          payload?.gstin?.length === GlobalConfiguration.lengthCheckZero &&
          !GSTStatus
        ? true
        : isBeneLookDataNull &&
            isVerifiedPan &&
            payload?.gstin?.length > GlobalConfiguration.lengthCheckZero &&
            payload?.gstin?.length < GlobalConfiguration.gstLength &&
            !GSTStatus
          ? false
          : isVerifiedPan && shouldLookupNext;

  const isBankStatusValid = bankStatus?.status === true;
  const isBankAccountValid =
    payload?.bank_account?.length > GlobalConfiguration.lengthCheckZero;
  const isIfscCodeValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength;
  const isVerifyBankValid = verifyBank?.status === true;
  const isUserName = payload?.userName !== "";
  const isPanName = payload?.account_name !== "";
  const isDefaultAmount = payload?.amount !== "";

  const shouldEnableNextButtonSecondStepper =
    !beneLookLoading &&
    !verifyBankisLoading &&
    isBankStatusValid &&
    isBankAccountValid &&
    isIfscCodeValid &&
    isVerifyBankValid &&
    (benebankLookData?.beneficiary_accounts?.length ===
      GlobalConfiguration.lengthCheckZero ||
      bankLookupNext);

  const isContactValid = contactBol.contact === true;
  const isEmailValid = contactBol.email === true;
  const isAccountNameValid = contactBol.accountname === true;
  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableTextColor: "var(--text-primary)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[GlobalConfiguration.lengthCheckZero],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled:
        (!nextButtonEnabled && !isButtonDisabled && !bankStatusLoading) ||
        manualVirtualAccount,
      stepperText: steps[GlobalConfiguration.lengthCheckOne],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[GlobalConfiguration.lengthCheckTwo],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !isButtonDisabled,
      stepperText: steps[GlobalConfiguration.lengthCheckThree],
    },
    {
      previousText: "Previous",
      nextText: "Create",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextEnableTextColor: "var(--text-primary)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsLoading: createFieldForceAccountLoading,
      nextIsEnabled: !nextButtonEnabled && !createDisabled,
      stepperText: steps[GlobalConfiguration.lengthCheckFour],
      nextLoaderNeeded: true,
    },
  ];

  const shouldEnableNextButtonThirdStepper =
    isContactValid &&
    isEmailValid &&
    isAccountNameValid &&
    isUserName &&
    isPanName &&
    isDefaultAmount;

  const [remPan, setRemPan] = useState("");

  const [newData, setNewData] = useState({
    gstin: "",
  });

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const specialRegex = /^[a-zA-Z0-9 ]*$/;

  const handleOpen = () => {
    setShowModalPopup(true);
  };

  const dataReceiveFromContact = (data) => {
    setContactBol(data);
  };
  const categoriesConfirmPage = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );
  const handleCreateAccount = async () => {
    if (createDisabled) return;

    setCreateDisabled(true);

    try {
      let updatedPayload = { ...payload, navigate };

      if (
        selectedFields.length === categoriesConfirmPage.length ||
        selectedFields.length === 0
      ) {
        updatedPayload.categoriesConfirmPage = null;
      } else {
        updatedPayload = {
          ...updatedPayload,
          categoriesConfirmPage: selectedFields.toString(),
        };
      }

      const data = await dispatch(
        createFieldForceAccount(updatedPayload),
      ).unwrap();

      const accountId = data.field_force_accounts[0].id;

      if (data?.status === true) {
        navigate(
          `/field_force_account_dashboard/create_field_force_account/success/${accountId}`,
          {
            replace: true,
          },
        );
      }
    } catch (error) {
      navigate(
        `/field_force_account_dashboard/create_field_force_account/error`,
        {
          replace: true,
          state: error?.errors,
        },
      );

      return error;
    } finally {
      setCreateDisabled(false);
    }
  };

  let haveApproved = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });

  let havePending = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBankApproved = bankData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });

  let haveBankPending = bankData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });

  const handleMainCreate = () => {
    if (benebankLookData?.status === undefined && beneLookError === true) {
      handleCreateAccount();
      // sessionStorage.setItem("Create BeneAcc Fresh PAN", false);
      // sessionStorage.setItem("Create BeneAcc Fresh Bank", false);
      // sessionStorage.removeItem("Create BeneAcc Approve and Decline status");
    } else if (
      !haveApproved &&
      !havePending &&
      !haveBankApproved &&
      !haveBankPending
    ) {
      handleCreateAccount();
      // sessionStorage.setItem("Create BeneAcc Fresh PAN", false);
      // sessionStorage.setItem("Create BeneAcc Fresh Bank", false);
      // sessionStorage.removeItem("Create BeneAcc Approve and Decline status");
    } else {
      handleOpen();
      // sessionStorage.removeItem("Create BeneAcc Approve and Decline status");
    }
  };

  const handleEnterKeyPress = (e) => {
    if (
      e.key === "Enter" &&
      activeStep === GlobalConfiguration.lengthCheckThree
    ) {
      handleMainCreate();
    }
    if (e.code === "Space") {
      setShowModalPopup(false);
    }
  };

  const renderCreateAccount = () => {
    switch (activeStep) {
      case 0:
        return (
          <CreateFieldForcePanDetails
            panNumber={payload.panNumber}
            isFocus={isFocus}
            setIsFocus={setIsFocus}
            verifiedPan={verifiedPan}
            handlePanChange={handlePanChange}
            panDetails={verifyPAN?.pan_details}
            beneLookData={beneLookData}
            beneLookLoading={beneLookLoading}
            lookupNext={lookupNext}
            setLookupNext={setLookupNext}
            BenEnableNextButton={BenEnableNextButton}
            verifyPANisLoading={verifyPANisLoading}
            isAchived={isAchived}
            setIsArchived={setIsArchived}
            setIsApproved={setIsApproved}
            isApproved={isApproved}
            accountType={accountType}
            setAccountType={setAccountType}
            isDennied={isDennied}
            setIsDennied={setIsDennied}
            setIsPending={setIsPending}
            isPending={isPending}
            shutViewAll={shutViewAll}
            setShutViewAll={setShutViewAll}
            disableCreateNext={disableCreateNext}
            setDisableCreateNext={setDisableCreateNext}
            showAction={showAction}
            setShowAction={setShowAction}
            isActive={isActive}
            setIsActive={setIsActive}
            setNewMessage={setNewMessage}
            newMessage={newMessage}
            beneLookError={beneLookError}
            setHideBlock={setHideBlock}
            setHideCreate={setHideCreate}
            hideBlock={hideBlock}
            hideCreate={hideCreate}
            type="createFlow"
            nonArchive={nonArchive}
            setNonArchive={setNonArchive}
            isLinkedAccount={isLinkedAccount}
            setIsLinkedAccount={setIsLinkedAccount}
            unachivedOpenPop={unachivedOpenPop}
            setUnachivedOpenPop={setUnachivedOpenPop}
            achivedOpenPop={achivedOpenPop}
            setAchivedOpenPop={setAchivedOpenPop}
            isButtonDisabled={isButtonDisabled}
            setPayload={setPayload}
            payload={payload}
            showAccInfo={showAccInfo}
            setShowAccInfo={setShowAccInfo}
            handleDeSelectConfirm={handleDeSelectConfirm}
            showRejectTnxPopup={showRejectTnxPopup}
            setRejectTxnPopup={setRejectTxnPopup}
            showRejectAllTxnReson={showRejectAllTxnReson}
            setShowRejectAllTxnReson={setShowRejectAllTxnReson}
            GSTStatus={GSTStatus}
            setGSTStatus={setGSTStatus}
            newData={newData}
            setNewData={setNewData}
          />
        );
      case 1:
        return (
          <FieldFieldBankDetails
            isButtonDisabled={isButtonDisabled}
            bankIsAchived={bankIsAchived}
            setBankIsArchived={setBankIsArchived}
            setBankIsApproved={setBankIsApproved}
            bankIsApproved={bankIsApproved}
            bankSelectedItem={bankSelectedItem}
            setBankSelectedItem={setBankSelectedItem}
            bankLookupNext={bankLookupNext}
            setBankLookupNext={setBankLookupNext}
            setBankIsPending={setBankIsPending}
            bankIsPending={bankIsPending}
            bankIsDennied={bankIsDennied}
            setBankIsDennied={setBankIsDennied}
            nextButtonEnabled={nextButtonEnabled}
            BenEnableNextButton={BenEnableNextButton}
            activeStep={activeStep}
            payload={payload}
            setPayload={setPayload}
            setBankShutViewAll={setBankShutViewAll}
            bankShutViewAll={bankShutViewAll}
            setBankDisableCreateNext={setBankDisableCreateNext}
            bankDisableCreateNext={bankDisableCreateNext}
            bankAccountType={bankAccountType}
            setBankAccountType={setBankAccountType}
            active={active}
            setActive={setActive}
            hideBankBlock={hideBankBlock}
            setBankHideBlock={setBankHideBlock}
            setBankAchivedOpenPop={setBankAchivedOpenPop}
            bankAchivedOpenPop={bankAchivedOpenPop}
            setBankUnachivedOpenPop={setBankUnachivedOpenPop}
            bankUnachivedOpenPop={bankUnachivedOpenPop}
            setBankUserInfo={setBankUserInfo}
            bankVerificationStatus={bankVerificationStatus}
            setBankVerificationStatus={setBankVerificationStatus}
            isIFSCValid={isIFSCValid}
            isBankError={isBankError}
            virtualAccount={virtualAccount}
            setVirtualAccount={setVirtualAccount}
            freshAccount={freshAccount}
            setFreshAccount={setFreshAccount}
            ownerAccIfscData={ownerAccIfscData}
            ownerAccIfscError={ownerAccIfscError}
            manualVirtualAccount={manualVirtualAccount}
            setManualVirtualAccount={setManualVirtualAccount}
          />
        );
      case 2:
        return (
          <FieldForceContactDetails
            payload={payload}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            setPayload={setPayload}
            categories={categories}
            onSelectFieldsChange={handleSelectFieldsChange}
            BenEnableNextButton={BenEnableNextButton}
            parentCreateBen={dataReceiveFromContact}
            activeStep={activeStep}
            showAlertCategories={showAlertCategories}
            setShowAlertCategories={setShowAlertCategories}
            handleNext={handleNext}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
            selectAllChecked={selectAllChecked}
            setSelectAllChecked={setSelectAllChecked}
            selectedCatFields={selectedCatFields}
            setSelectedCatFields={setSelectedCatFields}
            flow={flow}
            showRupeeSymbol={showRupeeSymbol}
            setShowRupeeSymbol={setShowRupeeSymbol}
            selectedValueAmount={selectedValueAmount}
            setSelectedValueAmount={setSelectedValueAmount}
          />
        );
      case 3:
        return (
          <FieldForceCategoryAndLabels
            payload={payload}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            setPayload={setPayload}
            categories={categories}
            onSelectFieldsChange={handleSelectFieldsChange}
            BenEnableNextButton={BenEnableNextButton}
            parentCreateBen={dataReceiveFromContact}
            activeStep={activeStep}
            showAlertCategories={showAlertCategories}
            setShowAlertCategories={setShowAlertCategories}
            handleNext={handleNext}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
            selectAllChecked={selectAllChecked}
            setSelectAllChecked={setSelectAllChecked}
            selectedCatFields={selectedCatFields}
            setSelectedCatFields={setSelectedCatFields}
            createRecipient={createRecipient}
            setCreateRecipient={setCreateRecipient}
            recipients={recipients}
            setRecipients={setRecipients}
          />
        );
      case 4:
        return (
          <FieldForceConfirmAccount
            payload={payload}
            selectedFields={selectedFields}
            bankAccountName={bankAccountName}
            setShowModalPopup={setShowModalPopup}
            showModalPopup={showModalPopup}
            bankUserInfo={bankUserInfo}
            recipients={createRecipient}
            flow={flow}
            remPan={remPan}
            createFieldForceAccountLoading={createFieldForceAccountLoading}
            setRemPan={setRemPan}
            manualVirtualAccount={manualVirtualAccount}
          />
        );
      default:
        return null;
    }
  };

  const handleKeyDown = (event) => {
    if (event.target.tagName === "INPUT") {
      // if (event.key === "Tab") {
      //   event.preventDefault();
      // }
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab" ||
      event.key === " "
    ) {
      event.preventDefault();
    }
  };

  const handleNext = () => {
    if (
      activeStep === 3 &&
      selectedFields?.length === categories?.length &&
      !showAlertCategories
    ) {
      setShowAlertCategories(true);
      setSelectedLabelsCreate(selectedLabelsCreate || []);
    } else if (activeStep === GlobalConfiguration.lengthCheckFour) {
      handleMainCreate();
    } else {
      // setButtonDisabled(true);
      setShowAlertCategories(false);
      setActiveStep(
        (prevActiveStep) => prevActiveStep + GlobalConfiguration.lengthCheckOne,
      );
      setDirection("next");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, 1000);
      // setTimeout(() => {
      //   setButtonDisabled(false);
      // }, 500);
    }
  };

  function capitalizeWords(str) {
    if (!str) return "";

    return str
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .map((word) => word[0].toUpperCase() + word.slice(1))
      .join(" ");
  }

  // Example

  const handleBack = () => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      navigate(GlobalConfiguration.lengthCheckNegativeOne);
      return;
    }
    // setButtonDisabled(true);
    setActiveStep(
      (prevActiveStep) => prevActiveStep - GlobalConfiguration.lengthCheckOne,
    );
    setDirection("previous");
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, 1000);
    // setTimeout(() => {
    //   setButtonDisabled(false);
    // }, 500);
  };

  const handleDeSelectConfirm = () => {
    setLookupNext(false);
    BenEnableNextButton(true);
  };

  const handleSelectFieldsChange = (selectedFields) => {
    setSelectedFields(selectedFields);
  };

  const handlePanChange = (e) => {
    setSelectedValue("legalname");
    const inputPan = e.target.value.toUpperCase();

    if (!specialRegex.test(inputPan)) {
      return;
    }

    if (inputPan.length > GlobalConfiguration.panLength) {
      return;
    }
    if (
      !panRegex.test(inputPan) &&
      inputPan.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
      dispatch(resetBeneData());
    } else if (inputPan.length === GlobalConfiguration.panLength) {
      dispatch(verifyThisPAN({ pan_number: inputPan, showToast: false }));
      setGSTStatus(null);
    } else {
      setVerifiedPan(null);
      BenEnableNextButton(true);
      setLookupNext(false);
      setShowAccInfo(false);
    }

    setPayload({ ...payload, panNumber: inputPan, gstin: "" });
    setAccountType({ type: "", id: "", name: "" });
    setIsArchived(false);
    setIsApproved(false);
    setIsDennied(false);
    setIsPending(false);
    setDisableCreateNext(false);
    setLookupNext(false);
    setNewMessage(true);
    setIsActive(false);
    setHideBlock(false);
    setHideCreate(false);
    dispatch(resetBeneVerifyThisGst());
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setRemPan(payload.panNumber);
  }, [payload.panNumber]);

  useEffect(() => {
    dispatch(beneCategories());
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, []);

  useEffect(() => {
    if (!verifyPANisLoading) {
      if (verifyPAN?.status === true) {
        setVerifiedPan(true);

        dispatch(beneLookUp({ pan_number: payload.panNumber }));
        setPayload({
          ...payload,
          legalName: verifyPAN?.pan_details?.full_name,
          account_name: capitalizeWords(verifyPAN?.pan_details?.full_name),
        });
      } else if (
        verifyPAN?.status === false &&
        payload?.panNumber.length === GlobalConfiguration.panLength
      ) {
        setVerifiedPan(false);
      }
    }
  }, [verifyPAN]);

  useEffect(() => {
    if (!verifyBankisLoading) {
      if (verifyBank?.status === true) {
        setBankAccountName(true);
        setBankAccountName(
          verifyBank?.verification_details[GlobalConfiguration.lengthCheckZero]
            ?.full_name,
        );
      }
    }
  }, [verifyBank]);

  useEffect(() => {
    dispatch(resetPANVerification());
    setVerifiedPan(null);
  }, []);

  useEffect(() => {
    if (
      benebankLookData?.status &&
      activeStep === GlobalConfiguration.lengthCheckOne
    ) {
      BenEnableNextButton(true);
    }
  }, [benebankLookData]);

  useEffect(() => {
    if (payload.ifsc_code?.length < GlobalConfiguration.ifscLength) {
      dispatch(resetBankError());
    }
    if (
      payload.bank_account?.length < GlobalConfiguration.accountnormalLength
    ) {
      const obj = { ...payload, ifsc_code: "" };
      setPayload(obj);
    }
    if (
      payload.bank_account?.length === 0 &&
      payload.ifsc_code?.length > GlobalConfiguration.lengthCheckZero
    ) {
      const newObj = { ...payload, ifsc_code: "" };
      setPayload(newObj);
      //  setBankVerificationStatus(false);
      BenEnableNextButton(true);
      dispatch(resetBankError());
    }
    if (
      payload.bank_account?.length >= GlobalConfiguration.accountnormalLength &&
      payload.ifsc_code?.length === GlobalConfiguration.ifscLength &&
      /^[A-Z]{4}0[A-Z0-9]{6}$/.test(payload.ifsc_code)
    ) {
      dispatch(
        beneVerifyThisBank({
          ifsc_code: payload.ifsc_code,
          bank_account: payload.bank_account,
          legal_name: payload.legalName,
          navigate: navigate,
        }),
      );
      dispatch(
        getOwnerAccountIFSCDetails({
          search_string: payload?.ifsc_code,
          page_no: GlobalConfiguration?.lengthCheckOne,
          page_size: GlobalConfiguration?.filterResults,
        }),
      );
    }
    if (
      createRecipient &&
      createRecipient.length > GlobalConfiguration.lengthCheckZero
    ) {
      setPayload((prev) => ({
        ...prev,
        recipient_email: createRecipient.join(","),
      }));
    } else {
      setPayload((prev) => {
        const updated = { ...prev };
        delete updated.recipient_email;
        return updated;
      });
    }
  }, [
    payload.ifsc_code,
    payload.bank_account,
    payload.legalName,
    createRecipient,
  ]);

  useEffect(() => {
    if (verifyBank?.status === true) {
      dispatch(
        beneBankLookUp({
          ifsc: payload.ifsc_code,
          bank_account_no: payload.bank_account,
        }),
      );
    }
  }, [verifyBank]);
  useEffect(() => {
    if (!beneBankLookLoading) {
      setTimeout(() => {
        if (isIFSCValid && !isBankError) {
          if (
            benebankLookData?.beneficiary_accounts?.length >
            GlobalConfiguration?.lengthCheckZero
          ) {
            setBankLookupNext(false);
          } else if (
            !verifyBankisLoading &&
            verifyBank?.status &&
            virtualAccount
          ) {
            setBankLookupNext(true);
            setFreshAccount(false);
          }
        }
      }, 0);
    }
    setFreshAccount(true);
  }, [
    beneBankLookLoading,
    benebankLookData,
    isBankError,
    isIFSCValid,
    virtualAccount,
    verifyBankisLoading,
    verifyBank,
  ]);
  useEffect(() => {
    if (isLoading || !services) return;

    if (!services.includes("FFUAccount")) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "FFUAccount" },
      });
    }
  }, [services, isLoading, navigate]);

  useEffect(() => {
    if (
      activeStep === GlobalConfiguration.lengthCheckZero &&
      !beneLookLoading
    ) {
      BenEnableNextButton(!shouldEnableNextButtonFirstStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckOne) {
      BenEnableNextButton(!shouldEnableNextButtonSecondStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckTwo) {
      BenEnableNextButton(!shouldEnableNextButtonThirdStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
      BenEnableNextButton(!true);
    } else if (activeStep === GlobalConfiguration.lengthCheckFour) {
      // setRemPan(payload.panNumber);
      BenEnableNextButton(false);
    }
  }, [
    activeStep,
    bankStatus?.status,
    contactBol?.contact,
    contactBol?.email,
    payload?.bank_account,
    payload?.ifsc_code,
    payload?.gstin,
    verifiedPan,
    verifyBank?.status,
    bankLookupNext,
    beneLookData,
    lookupNext,
    shouldEnableNextButtonFirstStepper,
    shouldEnableNextButtonSecondStepper,
    shouldEnableNextButtonThirdStepper,
    beneLookLoading,
    selectedFields,
    categories,
    showAlertCategories,
    beneBankLookLoading,
    benebankLookData,
    manualVirtualAccount,
  ]);

  useEffect(() => {
    if (newData.gstin?.length !== GlobalConfiguration.gstinLength) {
      setLookupNext(false);
    }
  }, [payload.gstin]);

  return (
    <>
      {showAlertCategories && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"It is unsafe to proceed"}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            headerWithIcon="https://q2pay.in/new_assets/common/dashboard/alert.svg"
            subtext="Assigning all categories to a single account is highly unsafe.
                  It is recommended to limit the number of categories assigned
                  to the account."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setShowAlertCategories(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => handleNext()}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="w-width-full flex flex-col items-center h-full-height bg-primary-bg">
        <div className="w-width-full">
          <div className="h-navbar-height hidden Qsmd:block"></div>
          <div className="h-[calc(var(--navbar-breadcrumb-height)-var(--navbar-height))] mt-margin-sm Qsmd:my-margin-base"></div>
        </div>

        <div className="flex justify-center items-end !bottom-bottom-base rounded-t-border-radius-md Qsmd:relative min-h-stepper-height Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-md w-screen fixed Qsmd:top-top-base left-left-base z-z-index-header">
          <PrimaryStepper
            activeStep={activeStep}
            handleForwardAction={handleNext}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>

        <div className="flex items-center w-width-full bg-primary-nav p-padding-sm fixed left-left-base top-top-base z-z-index-header Qsmd:hidden shadow-box-shadow-bottom">
          <div
            onClick={() => navigate(GlobalConfiguration.lengthCheckNegativeOne)}
          >
            <SVGComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              color={"var(--text-primary)"}
              height={"var(--icon-md)"}
              width={"var(--icon-md)"}
              alt="Arrow"
            />
          </div>

          <div className=" flex flex-col pl-padding-md ">
            <p className=" text-font-md font-sans text-text-primary">
              {" "}
              Field Force Account
            </p>
            {activeStep === GlobalConfiguration.lengthCheckZero && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                Enter PAN details
              </p>
            )}
            {activeStep === GlobalConfiguration.lengthCheckOne && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                Enter bank details
              </p>
            )}
            {activeStep === GlobalConfiguration.lengthCheckTwo && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                Enter User, transaction limit and contact details
              </p>
            )}
            {activeStep === GlobalConfiguration.lengthCheckThree && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                Category and labels
              </p>
            )}
            {activeStep === GlobalConfiguration.lengthCheckFour && (
              <p className="text-font-xs font-sans text-text-primary">
                {" "}
                Confirm and create account
              </p>
            )}
          </div>
        </div>

        <>
          <div
            className="max-w-tab-width-normal mx-auto overflow-hidden h-full flex flex-col items-center relative w-width-full"
            ref={scrollIt}
          >
            {/* <div className="h-mobile-create-header w-width-full hidden Qsmd:block flex-shrink-0"></div> */}
            <div
              className={`w-width-full h-full overflow-auto Qsmd:pt-padding-lg Qsmd:pb-padding-md pt-padding-base ${
                activeStep === GlobalConfiguration.lengthCheckZero &&
                direction === "next"
                  ? ""
                  : removeClassName === true
                    ? ""
                    : animationClass
              }`}
              style={{
                scrollbarWidth: "none",
              }}
            >
              {renderCreateAccount()}
            </div>
          </div>
        </>

        <div className="h-mobile-create-header flex-shrink-0 w-width-full Qsmd:hidden block"></div>
      </div>
    </>
  );
};

export default FieldForceAccountCreate;
